/* eslint-disable react/require-default-props */
import React from 'react';
import './DetailSection.scss';
import { Button } from '@ui';
function DetailSection({ title, children, action, onActionClick }) {
    return (React.createElement("div", { className: "tab-section" },
        React.createElement("div", { className: "tab-header" },
            React.createElement("h3", { className: "section-title" }, title),
            React.createElement("div", { className: "title-line" }),
            action && onActionClick && (React.createElement("div", { className: "tab-actions" },
                React.createElement(Button, { variant: "secondary", onClick: onActionClick }, action)))),
        children));
}
export default DetailSection;
